export const ECHEANCE_ENREGISTRER = 'Enregistre';
export const ECHEANCE_BROUILLON = 'Brouillon';
export const ECHEANCE_FACTURE = 'Facture';
export const ECHEANCE_FACTURE_PARTIELLEMENT = 'FactureePartiellement';
export const ECHEANCE_PAYEE = 'Paye';

export const ACTION_SOLDER_SANS_FACTURE = 'solderSansFacture';
export const ACTION_REACTIVER_ECHEANCE_SOLDEE = 'reactiverEcheanceSoldee';
export const ACTION_GENERATION_FACTURE = 'generationFacture';
